import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, WritableSignal, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DumpingModalComponent } from '@shared/components/dumping-modal/dumping-modal.component';
import * as moment from 'jalali-moment';

@Injectable({
 providedIn: 'root',
})
export class UtmService {
 constructor(
  private dialog: MatDialog,
  @Inject(PLATFORM_ID) private platformId: Object,
  @Inject(DOCUMENT) private document: Document
 ) {}

 utmImageSource: WritableSignal<string> = signal('');
 utmQueryString = '';
 safarmarketId: WritableSignal<string> = signal('');

 setUtmImageSource(imageSource: string) {
  this.utmImageSource.set(imageSource);
 }

 checkRouteParams(queryParamMap: any) {
  let utm_source = queryParamMap.get('utm_source');
  let utm_medium = queryParamMap.get('utm_medium');
  let utm_content = queryParamMap.get('utm_content');
  let utm_campaign = queryParamMap.get('utm_campaign');

  if (!utm_medium) {
   utm_source = this.getCookie('utm_source');
   utm_medium = this.getCookie('utm_medium');
   utm_content = this.getCookie('utm_content');
  }

  const safarmarketId = [null, '', undefined].includes(queryParamMap.get('safarmarketId'))
   ? this.getCookie('safarmarketId')
   : queryParamMap.get('safarmarketId');

  if (utm_medium && utm_content) {
   let content: string = `utm_medium=${utm_medium}&utm_content=${utm_content}`;

   if (utm_source) {
    content += `&utm_source=${utm_source}`;
    if (
     !queryParamMap.get('page') &&
     (utm_source === 'webengage' ||
      utm_source === 'yektanet' ||
      utm_source === 'shomal' ||
      utm_source === 'jonoob' ||
      utm_source === 'yektanet.com' ||
      utm_source === 'yektanet1.com' ||
      utm_source === 'yektanet2.com' ||
      utm_source === 'yektanet3.com' ||
      utm_source === 'mygearbox' ||
      utm_source === 'telegram.com' ||
      utm_source === 'instagram.com')
    ) {
     if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
       this.dialog.open(DumpingModalComponent, {
        panelClass: 'custom-modal',
        data: utm_source,
       });
      }, 100);
     }
    }
    if (
     // utm_source === 'safarmarket.ir' ||
     // utm_source == 'ads.google.com' ||
     utm_source == 'BankSaman' ||
     utm_source == 'kojaro.com' ||
     utm_source == 'seeiran.ir' ||
     utm_source == 'varzesh3.com'
    ) {
     if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
       this.dialog.open(DumpingModalComponent, {
        panelClass: 'custom-modal',
        data: utm_source,
       });
      }, 5000);
     }
    }
   }

   if (utm_campaign) {
    content += `&utm_campaign=${utm_campaign}`;
   }

   if (queryParamMap.get('utm_source')) {
    Object.entries(queryParamMap.params).forEach(([key, value]) => {
     if (
      !content
       .split('&')
       .map((param) => param.split('=')[0])
       .includes(key)
     )
      content += `&${key}=${
       key == 'utm_term' || key == 'adgroupname' ? encodeURIComponent(value as string) : value
      }`;
    });
   }

   this.utmQueryString = content;
  }

  if (safarmarketId) {
   this.setSafarmarketId(safarmarketId);
   this.utmQueryString = this.utmQueryString ?? `safarmarketId=${safarmarketId}`;
   if (!this.utmQueryString.includes('safarmarketId'))
    this.utmQueryString += `&safarmarketId=${safarmarketId}`;
  }
 }

 private getCookie(name: string) {
  if (isPlatformBrowser(this.platformId)) {
   let ca: Array<string> = this.document.cookie.split(';');
   let caLen: number = ca?.length;
   let cookieName = `${name}=`;
   let c: string;

   for (let i: number = 0; i < caLen; i += 1) {
    c = ca[i].replace(/^\s+/g, '');
    if (c.indexOf(cookieName) == 0) {
     return c.substring(cookieName?.length, c?.length);
    }
   }
   return '';
  }
  return '';
 }

 private setSafarmarketId(safarmarketId: string) {
  this.safarmarketId.set(safarmarketId);
 }
}
